import WebHttpClient from '~src/httpClient/WebHttpClient';
import { GetSiteSettingsForSiteAdminRequest } from '~src/settings/ServerApi/requests/siteSettings/GetSiteSettingsForSiteAdminRequest';
import { IUpdateSiteSettingsForSiteAdminResult, UpdateSiteSettingsForSiteAdminRequest } from '~src/settings/ServerApi/requests/siteSettings/UpdateSiteSettingsForSiteAdminRequest';
import { ISiteSettingsForSiteAdmin } from '~src/settings/types/ISiteSettingsForSiteAdmin';

export function updateSiteSettings(request: UpdateSiteSettingsForSiteAdminRequest): Promise<IUpdateSiteSettingsForSiteAdminResult>  {
    const isComplete = (result: IUpdateSiteSettingsForSiteAdminResult): boolean => {
      return result != null;
    };

    return WebHttpClient.sendRequest(request);
  }

export function getSiteSettings(siteId: string): Promise<ISiteSettingsForSiteAdmin> {
  const isComplete = (result: IUpdateSiteSettingsForSiteAdminResult): boolean => {
    return result != null;
  };

  return WebHttpClient.sendRequest(new GetSiteSettingsForSiteAdminRequest({ id: siteId }));
}

  export const UpdateSiteSettingsService = {
    updateSiteSettings: updateSiteSettings,
  };